/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Risk_Tier_MediumInputs */



/**
* | output |
* | --- |
* | "MEDIUM" |
*
* @param {Chat_Risk_Tier_MediumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_risk_tier_medium = /** @type {((inputs?: Chat_Risk_Tier_MediumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Risk_Tier_MediumInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("MITTEL")
	return /** @type {LocalizedString} */ ("MEDIUM")
});